<div class="signature-pad">
  <label *ngIf="label" class="signature-pad__label">{{ label }}</label>
  <div
    class="signature-pad__viewport"
    [class.signature-pad__viewport--clipped]="topReserveRatio > 0"
    [style.--reserve]="topReserveRatio"
    [style.aspect-ratio]="signableAspect">
    <canvas
      #signatureCanvas
      class="signature-pad__canvas"
      (mousedown)="startDrawing($event)"
      (mousemove)="draw($event)"
      (mouseup)="stopDrawing()"
      (mouseleave)="stopDrawing()">
    </canvas>
  </div>
  <div class="signature-pad__actions" *ngIf="!disabled">
    <button type="button" class="btn btn-link btn-sm" (click)="clear()">Limpiar</button>
    
    <input
      *ngIf="allowAttach"
      #fileInput
      type="file"
      accept="image/png,image/jpeg"
      hidden
      (change)="onFileSelected($event)" />
  </div>
</div>
